import { TabularGridColumnSortChangedEvent } from "@genexus/chameleon-controls-library";

const sortTabularGridColumn = (
  e: CustomEvent<TabularGridColumnSortChangedEvent>,
  rowsArrayData: unknown[],
  dateType: SortTabularGridColumnDataType = "string",
  objectProperty?: any
): any[] => {
  const { columnId, sortDirection } = e.detail;

  // date or dateString
  if (dateType === "date" || dateType === "dateString") {
    return rowsArrayData.sort((a: any, b: any) => {
      const columnA = a[columnId];
      const columnB = b[columnId];

      if (dateType === "dateString") {
        a = new Date(columnA);
        b = new Date(columnB);
      }

      if (columnA.getTime() < columnB.getTime()) {
        return sortDirection === "asc" ? -1 : 1;
      }
      if (columnA.getTime() > columnB.getTime()) {
        return sortDirection === "asc" ? 1 : -1;
      }
      return 0;
    });
  }

  // number
  if (dateType === "number") {
    return rowsArrayData.sort((a: any, b: any) => {
      const columnA = Number(a[columnId]);
      const columnB = Number(b[columnId]);

      return sortDirection === "asc" ? columnA - columnB : columnB - columnA;
    });
  }

  // string or objectProperty
  return rowsArrayData.sort((a: any, b: any) => {
    const columnA = objectProperty
      ? a[columnId][objectProperty]
      : (a[columnId] as string);
    const columnB = objectProperty
      ? b[columnId][objectProperty]
      : (b[columnId] as string);

    if (columnA < columnB) {
      return sortDirection === "asc" ? -1 : 1;
    }
    if (columnA > columnB) {
      return sortDirection === "asc" ? 1 : -1;
    }
    return 0;
  });
};

export default sortTabularGridColumn;

export type SortTabularGridColumnDataType =
  | "string"
  | "number"
  | "date"
  | "dateString"
  | "object";
